export const TRADER_REQUISITES_REFRESH_INTERVAL_MS = 5000;
export const TRADER_BALANCE_REFRESH_INTERVAL_MS = 10000;

